import { ChipsSelect, Chip, CustomSelectOption, FormItem } from '@vkontakte/vkui';
import { UserAvatar } from '../../components/UserAvatar';
import PropTypes from 'prop-types';

export const MembersInputComponent = ({error, setError, members, value, setValue, label, placeholder, allItemsLabel}) => {
  const options = (value || []).length === (members || []).length ? members : [{value: 'all', label: allItemsLabel, img: null}, ...members];

  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <ChipsSelect
      onChange={(items) => setValue(items)}
      onChangeStart={(e, option) => {
        if (option.value === 'all') {
          e.preventDefault();
          setValue(members);
        }
      }}
      options={options}
      value={value || undefined}
      placeholder={placeholder}
      selectedBehavior="hide"
      closeAfterSelect={true}
      renderChip={({ value, label, ...rest }, option) => {
        return (<Chip
          value={option.value}
          before={<UserAvatar
            size={24}
            type={option.type || undefined}
            src={option.img}
            name={option.label}
            id={parseInt(option.value)}
            length={option.value === 'all' ? 3 : 2}
          />}
          {...rest}
        >
          {label}
        </Chip>);
      }}
      renderOption={(props, option) => {
        return (
          <CustomSelectOption
            before={<UserAvatar
              size={24}
              type={option.type || undefined}
              src={option.img}
              name={option.label}
              id={option.value === 'all' ? 0 : parseInt(option.value)}
              length={option.value === 'all' ? 3 : 2}
            />}
            {...props}
          />
        );
      }}
    />
  </FormItem>);
}

const members = PropTypes.shape({
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  label: PropTypes.string.isRequired,
  img: PropTypes.string,
  type: PropTypes.string.isRequired,
});

MembersInputComponent.propTypes = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  members: PropTypes.arrayOf(members.isRequired).isRequired,
  value: PropTypes.arrayOf(members.isRequired).isRequired,
  setValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  allItemsLabel: PropTypes.string.isRequired,
}
